import React, { useEffect, useState } from "react";
import { Button } from "antd";
import BrandCards, { BrandOption } from "./BrandCards";

interface Props {
  brands: BrandOption[];
  value: string[];
  onCancel: () => void;
  onApply: (value: string[]) => void;
}

export default function BrandDropdown({ brands, value, onCancel, onApply }: Props) {
  const [draft, setDraft] = useState<string[]>(value);

  useEffect(() => setDraft(value), [value]);

  return (
    <div className="v2-brand-dropdown">
      <h3 className="v2-filters__title">Brand</h3>

      <BrandCards
        brands={brands}
        selected={draft}
        variant="row-radio"
        columns={2}
        onToggle={(brand) =>
          setDraft(draft.includes(brand) ? draft.filter((item) => item !== brand) : [...draft, brand])
        }
      />

      <div className="v2-brand-dropdown__footer">
        <Button type="text" className="v2-filters__clear" onClick={() => setDraft([])}>
          Clear
        </Button>
        <Button className="v2-brand-dropdown__cancel" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="primary" className="v2-filters__apply" onClick={() => onApply(draft)}>
          Apply
        </Button>
      </div>
    </div>
  );
}
